import React, { Component } from "react";
import {
    Col,
    Row,
    Nav,
    Card,
    Table,
    Form,
    Button,
    ButtonGroup,
    Breadcrumb,
    InputGroup,
    Dropdown,

} from "@themesberg/react-bootstrap";
import SpinDiv from "../../components/SpinDiv";
import ReactDatetime from "react-datetime";
import moment from "moment";
import { toast } from "react-toastify";
import { getMarkedDepartmentPerformances } from "../../../services/departmentPerformanceService";
import { Tooltip } from 'antd';
import {faCheck, faBoxOpen,faUsers,  faStepForward, faEnvelope, faAngleUp} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Rate } from 'antd';
import Chart from "react-apexcharts";
import { Popover} from 'antd';

const attendanceOverview = (
  <div>
    <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="pb-0">
            <p>Weekly Attendance is calcuted as follows</p>
            <p>Working Hours for a week = No of Days of week x 9hrs</p>
            <p> Employee working Hours for a week = Attendance (total No of hours worked) X No of working Days</p>
            <h6> Attendance Percentage =   (Employee working Hours for a week /  Employee working Hours for a week) x 20</h6>

        </Card.Body>
    </Card>
  </div>
);
const performanceOverview = (
    <div>
      <Card border="light" className="shadow-sm mb-4">
          <Card.Body className="pb-0">
              <h5>Performance</h5>
              <p>(Sum total Rating / No of weeks (No of time it was rated) x 5) x 100</p>
              <p>This arithmetic operation works for service_knowledge , Policy and Compliance, customer_service_satisfaction , Training & Development</p>
             
  
          </Card.Body>
      </Card>
    </div>
  );



export class ViewAdministrativePerformance extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            search: '',
            validation: {},
            show: false,
            edit: false,
            id: props.match.params.id,
            year:props.match.params.year,
            month:props.match.params.month,
            performances:[],
            overall_teamwork:0,
            overall_customer_conversion_rate:0,
            overall_response_time:0,
            overall_service_knowledge:0,
            overall_customer_service_satisfaction:0
    
        };
    }

    componentDidMount() {
        toast.configure({ hideProgressBar: true, closeButton: false });
        this.getMarkedPerformances();
        
    }





    getMarkedPerformances = () => {
        const { id } = this.state;
        this.setState({  loading: true})
        getMarkedDepartmentPerformances(id).then(
            
            (res) => {
                this.setState({
                    performances: res.marked_performances,
                    loading: false
                });
            },
            (error) => {
                this.setState({ loading: false });
            }
        );
    };
    sumArray(arr){
        const sum = arr.reduce((partialSum, a) => partialSum + a, 0);
        return sum;
    }


    getCustomerServicePercentage(performances){
        let customer_service_satisfaction =[];
        let total_customer_service_satisfaction  = performances.length*5;
        performances.map((p, index)=>{
            return customer_service_satisfaction .push( p.customer_service_satisfaction );
        })
       
         let percentage = (this.sumArray(customer_service_satisfaction )/total_customer_service_satisfaction )*100;
         return Math.round(percentage);
        

    }

    getTeamWorkPercentage(performances){
        let teamwork =[];
        let total_teamwork  = performances.length*5;
        performances.map((p, index)=>{
            return teamwork .push( p.teamwork );
        })
       
         let percentage = (this.sumArray(teamwork )/total_teamwork )*100;
         return Math.round(percentage);
        

    }

     getCustomerConversionPercentage(performances){
        let customer_conversion_rate =[];
        let total_customer_conversion_rate  = performances.length*5;
        performances.map((p, index)=>{
            return customer_conversion_rate .push( p.customer_conversion_rate );
        })
       
         let percentage = (this.sumArray(customer_conversion_rate )/total_customer_conversion_rate )*100;
         return Math.round(percentage);
        

    }

     getResponseTimePercentage(performances){
        let response_time=[];
        let total_response_time = performances.length*5;
        performances.map((p, index)=>{
            return response_time.push( p.response_time);
        })
       
         let percentage = (this.sumArray(response_time)/total_response_time)*100;
       
         return Math.round(percentage);
         
    }
    

    getServiceKnowledgePercentage(performances){
        let service_knowledge =[];
        let total_service_knowledge  = performances.length*5;
        performances.map((p, index)=>{
            return service_knowledge .push( p.service_knowledge );
        })
       
         let percentage = (this.sumArray(service_knowledge )/total_service_knowledge )*100;
         return Math.round(percentage);
        

    }

   
    
   

    monthName = (mon)=> {
        return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][mon - 1];
    }

    getName(performances){
        var name = performances.map(function(p) {
           return p.department_name;
       });
       return name[0];
   }

    weeklyPerformanceChat(performances){
        
        const week_one_performances = performances.filter(p => p.week == 1);
        const week_two_performances = performances.filter(p => p.week == 2);
        const week_three_performances = performances.filter(p => p.week == 3);
        const week_four_performances = performances.filter(p => p.week == 4);
    
       
    
        let service_knowledge_one= week_one_performances.length !== 0 ? (this.getServiceKnowledgePercentage(week_one_performances)/100)*20 : 0;
        let service_knowledge_two= week_two_performances.length !== 0 ? (this.getServiceKnowledgePercentage(week_two_performances)/100)*20 : 0;
        let service_knowledge_three= week_three_performances.length !== 0 ? (this.getServiceKnowledgePercentage(week_three_performances)/100)*20 : 0;
        let service_knowledge_four= week_four_performances.length !== 0 ? (this.getServiceKnowledgePercentage(week_four_performances)/100)*20 : 0;
        
        let customer_service_satisfaction_one= week_one_performances.length !== 0 ? (this.getCustomerServicePercentage(week_one_performances)/100)*20 : 0;
        let customer_service_satisfaction_two= week_two_performances.length !== 0 ? (this.getCustomerServicePercentage(week_two_performances)/100)*20 : 0;
        let customer_service_satisfaction_three= week_three_performances.length !== 0 ? (this.getCustomerServicePercentage(week_three_performances)/100)*20 : 0;
        let customer_service_satisfaction_four= week_four_performances.length !== 0 ? (this.getCustomerServicePercentage(week_four_performances)/100)*20 : 0;

        let response_time_one= week_one_performances.length !== 0 ? (this.getResponseTimePercentage(week_one_performances)/100)*20 : 0;
        let response_time= week_two_performances.length !== 0 ? (this.getResponseTimePercentage(week_two_performances)/100)*20 : 0;
        let response_time_three= week_three_performances.length !== 0 ? (this.getResponseTimePercentage(week_three_performances)/100)*20 : 0;
        let response_time_four= week_four_performances.length !== 0 ? (this.getResponseTimePercentage(week_four_performances)/100)*20 : 0;

        let customer_conversion_rate_one= week_one_performances.length !== 0 ? (this.getCustomerConversionPercentage(week_one_performances)/100)*20 : 0;
        let customer_conversion_rate_two= week_two_performances.length !== 0 ? (this.getCustomerConversionPercentage(week_two_performances)/100)*20 : 0;
        let customer_conversion_rate_three= week_three_performances.length !== 0 ? (this.getCustomerConversionPercentage(week_three_performances)/100)*20 : 0;
        let customer_conversion_rate_four= week_four_performances.length !== 0 ? (this.getCustomerConversionPercentage(week_four_performances)/100)*20 : 0;

        let teamwork_one= week_one_performances.length !== 0 ? (this.getTeamWorkPercentage(week_one_performances)/100)*20 : 0;
        let teamwork_two= week_two_performances.length !== 0 ? (this.getTeamWorkPercentage(week_two_performances)/100)*20 : 0;
        let teamwork_three= week_three_performances.length !== 0 ? (this.getTeamWorkPercentage(week_three_performances)/100)*20 : 0;
        let teamwork_four= week_four_performances.length !== 0 ? (this.getTeamWorkPercentage(week_four_performances)/100)*20 : 0;

    
        let overall_week_one_performance = service_knowledge_one+customer_conversion_rate_one+response_time_one+customer_service_satisfaction_one+teamwork_one;
        let overall_week_two_performance = service_knowledge_two+customer_conversion_rate_two+response_time+customer_service_satisfaction_two+teamwork_two;
        let overall_week_three_performance = service_knowledge_three+customer_conversion_rate_three+response_time_three+customer_service_satisfaction_three+teamwork_three;
        let overall_week_four_performance = service_knowledge_four+customer_conversion_rate_four+response_time_four+customer_service_satisfaction_four+teamwork_four;

       
        const data  = {
            options: {
              chart: {
                id: "basic-bar"
              },
              xaxis: {
                categories: ['WEEK 1', 'WEEK 2', 'WEEK 3', 'WEEK 4']
              }
            },
            series: [
              {
                name: "Weekly overall-performance",
                data: [overall_week_one_performance,overall_week_two_performance,overall_week_three_performance,overall_week_four_performance,100]
              }
            ]
          };
          return (
              <Chart
              options={data.options}
              series={data.series}
              type="line"
              width="750"
              height="250"
            />
          )
    }

    performanceChart = (performances) => {
        let service_knowledge = this.getServiceKnowledgePercentage(performances);
        let customer_service_satisfaction = this.getCustomerServicePercentage(performances);
        let response_time= this.getResponseTimePercentage(performances);
        let customer_conversion_rate = this.getCustomerConversionPercentage(performances);
        let teamwork = this.getTeamWorkPercentage(performances);
        
        const data  = {
          options: {
            chart: {
              id: "basic-bar"
            },
            xaxis: {
              categories: ['','SERVICE KNOWLEDGE', 'RESPONSE TIME','CUSTOMER SERVICE', 'CUSTOMER CONVERSION', 'TEAM WORK','']
            }
          },
          series: [
            {
              name: "overall-performance",
              data: [0, service_knowledge ,response_time,customer_service_satisfaction, customer_conversion_rate,teamwork ,100 ]
            }
          ]
        };
        return (
            <Chart
            options={data.options}
            series={data.series}
            type="line"
            width="750"
            height="250"
          />
        )
    }

    render() {

        const { saving, month, year, loading, performances } = this.state;
        return (
            <>


                {loading && <SpinDiv text={"Loading..."} />}
                <Row style={{}}>
                    <Col lg="12">
                        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                            <div className="d-block mb-4 mb-md-0">
                                <Breadcrumb
                                    listProps={{
                                        className: " breadcrumb-text-dark text-primary",
                                    }}
                                >
                                    <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                                    <Breadcrumb.Item href="/performances">Performance</Breadcrumb.Item>
                                    <Breadcrumb.Item href="#">Detail</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <div className="btn-toolbar mb-2 mb-md-0">
                                <ButtonGroup>

                                    {/* <Button variant="outline-primary" size="sm">
                                        Export
                                    </Button> */}
                                </ButtonGroup>
                            </div>
                        </div>
                    </Col>
                    <Row>
                        <Col md={12}>
                            <Card border="light" className="shadow-sm mb-4">
                                <Card.Body className="pb-0">
                                    <Row>
                                        <Col md={8}></Col>
                                        <Col md={4} style={{marginBottom:10}}>
                                            
                                                
                                                <ButtonGroup>
                                                    {/* <Button variant="outline-primary" size="sm">
                                                        <Popover content={attendanceOverview} title="Attendance Overview">
                                                            Attendance overview
                                                        </Popover>
                                                    </Button> */}
                                                    <Button variant="outline-primary" size="sm">
                                                        <Popover content={performanceOverview} title="Performance Overview">
                                                            Performance OverView
                                                        </Popover>
                                                    </Button>
                                                </ButtonGroup>
                                           
                                        </Col>
                                    </Row>
                                    <Table
                                    responsive
                                    className="table-centered table-nowrap rounded mb-0"
                                        style={{marginBottom:10, fontSize:30}}
                                    >
                                    <thead className="thead-light">
                                        <tr>
                                        <th className="border-0" style={{fontSize:15}}>Department: {this.getName(performances)} </th>
                                        <th className="border-0" style={{fontSize:15}}>Date: {this.monthName(month)}, {year}</th>
                                        
                                        
                                        </tr>
                                    </thead>
                                    
                                    
                                    </Table>
                                
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Col md={12}>
                       

                        <Card border="light" className="shadow-sm mb-4">
                            <Card.Body className="pb-0">
                               <Row style={{marginBottom:10}}>
                                    
                                   <Col md={2}>
                                        <Card border="light" className="shadow-sm mb-4" style={{ color:'grey', fontWeight:'bold'}} >
                                            <Row style={{textAlign:'center', padding:10,}}>
                                               <Col md={12} style={{fontSize:15}}>
                                                    Customer Service Satisfaction
                                               </Col>
                                               <Col md={12}>
                                                 <FontAwesomeIcon color='grey' style={{fontSize:20, paddingTop:5}} icon={faEnvelope}  />
                                                </Col>
                                                 <h6 style={{ color:'blue', padding:10,  fontWeight:'bold'}}>{this.getCustomerServicePercentage(performances)+'%'}</h6>
                                            </Row>       
                                        </Card>
                                    </Col>
                                    <Col md={2}>
                                        <Card border="light" className="shadow-sm mb-4" style={{ color:'grey', fontWeight:'bold'}} >
                                            <Row style={{textAlign:'center', padding:10,}}>
                                               <Col md={12} style={{fontSize:15}}>
                                                     Conversion Rate
                                               </Col>
                                               <Col md={12}>
                                                 <FontAwesomeIcon color='grey' style={{fontSize:20, paddingTop:5}} icon={faStepForward}  />
                                                </Col>
                                                 <h6 style={{ color:'blue', padding:10,  fontWeight:'bold'}}>{this.getCustomerConversionPercentage(performances)+'%'}</h6>
                                            </Row>       
                                        </Card>
                                    </Col>
                                    <Col md={2}>
                                        <Card border="light" className="shadow-sm mb-4" style={{ color:'grey', fontWeight:'bold'}} >
                                            <Row style={{textAlign:'center', padding:10,}}>
                                               <Col md={12} style={{fontSize:15}}>
                                                     Response Time
                                               </Col>
                                               <Col md={12}>
                                                 <FontAwesomeIcon color='grey' style={{fontSize:20, paddingTop:5}} icon={faAngleUp}  />
                                                </Col>
                                                 <h6 style={{ color:'blue', padding:10,  fontWeight:'bold'}}>{performances.length !== 0 ?this.getResponseTimePercentage(performances)+'%': '0%'}</h6>
                                            </Row>       
                                        </Card>
                                    </Col>
                                    <Col md={2}>
                                        <Card border="light" className="shadow-sm mb-4" style={{ color:'grey', fontWeight:'bold'}} >
                                            <Row style={{textAlign:'center', padding:10,}}>
                                               <Col md={12} style={{fontSize:15}}>
                                                     Team work
                                               </Col>
                                               <Col md={12}>
                                                 <FontAwesomeIcon color='grey' style={{fontSize:20, paddingTop:5}} icon={faBoxOpen}  />
                                                </Col>
                                                 <h6 style={{ color:'blue', padding:10,  fontWeight:'bold'}}>{this.getTeamWorkPercentage(performances)+'%'}</h6>
                                            </Row>       
                                        </Card>
                                    </Col>
                                    <Col md={2}>
                                        <Card border="light" className="shadow-sm mb-4" style={{ color:'grey', fontWeight:'bold'}} >
                                            <Row style={{textAlign:'center', padding:10,}}>
                                               <Col md={12} style={{fontSize:15}}>
                                                     Service Knowoledge
                                               </Col>
                                               <Col md={12}>
                                                 <FontAwesomeIcon color='grey' style={{fontSize:20, paddingTop:5}} icon={faBoxOpen}  />
                                                </Col>
                                                 <h6 style={{ color:'blue', padding:10,  fontWeight:'bold'}}>{this.getServiceKnowledgePercentage(performances)+'%'}</h6>
                                            </Row>       
                                        </Card>
                                    </Col>
                                   
                                    
                               </Row>
                              

                        
                            </Card.Body>
                            <Row style={{margin:10}}>
                                <Col md={12}>
                                    <Card border="light" className="shadow-sm mb-4">
                                        <Card.Body className="pb-0">
                                            <Table
                                            responsive
                                            className="table-centered table-nowrap rounded mb-0"
                                            >
                                            <thead className="thead-light">
                                                <tr>
                                                <th className="border-0">No</th>
                                                <th className="border-0">Week</th>
                                                <th className="border-0">Customer Service</th>
                                                <th className="border-0">Customer Conversion Rate</th>
                                                <th className="border-0">Response Time</th>
                                                <th className="border-0">Team Work</th>
                                                <th className="border-0">Service Knowledge</th>
                                               
                                                </tr>
                                            </thead>
                                            <tbody>
                                                
                                                {performances.map((performance, key) => {
                                            
                                                return (
                                                    <tr style={{fontWeight:"bold"}}>
                                                    <th scope="row">
                                                        <td><span className="mb-0 text-sm" style={{fontWeight:"bold",textTransform:"capitalize"}}>{key+1}</span></td>
                                                        
                                                    </th>
                                                
                                                    <td>{performance.week}</td>
                                                    <td><Rate style={{color:'green'}} value={performance.customer_service_satisfaction } /></td>
                                                    <td><Rate style={{color:'green'}} value={performance.customer_conversion_rate } /></td>
                                                    <td><Rate style={{color:'green'}} value={performance.response_time} /></td>
                                                    <td><Rate style={{color:'green'}} value={performance.teamwork} /></td>
                                                    <td><Rate style={{color:'green'}} value={performance.service_knowledge } /></td>
                                                    
                                                   
                                                    
                                                    
                                                    </tr>
                                                );
                                                })}
                                            </tbody>
                                            
                                            </Table>
                                            
                                        </Card.Body>
                                        </Card>
                                </Col>
                            </Row>
                            <Row>
                               <Col md={2}></Col>

                               <Col md={10}>
                                    <h5>Weekly Overall Performance</h5>
                                    {this.weeklyPerformanceChat(performances)}
                               </Col>
                            </Row>
                            <Row>
                               <Col md={2}></Col>
                               <Col md={10} style={{marginBottom:20}}>
                                <h5>Performance BreakDown Graph</h5>
                                {this.performanceChart(performances)}
                               </Col>
                            </Row>
                        </Card>
                    </Col>

                </Row>

            </>
        );
    }
}

export default ViewAdministrativePerformance;
